module.exports = __webpack_public_path__ + "img/Stretcher.46193155.svg";